import styled from 'styled-components';

import {colors, border, font, icons, breakpoint} from '../theme';

import {Link} from './ui-kit/Link';

export const Root = styled.div`
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
    height: auto;
    background-color: white;
    border-radius: 6px;

    @media (max-width: ${breakpoint.tablet}) {
        min-width: ${breakpoint.tablet};
        height: max-content;
    }
`;

export const HeadControl = styled.div`
    display: flex;
    width: 100%;
    height: auto;
    justify-content: space-between;
    align-items: flex-start;

    @media (max-width: ${breakpoint.tablet}) {
        min-width: ${breakpoint.tablet};
    }
`;

export const Button = styled.button`
    width: auto;
    height: auto;
    padding: 10px 16px;
    background-color: ${colors.brandPrimary};
    color: ${colors.white};
    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 2%;
    border: 0;
    outline: 0;
    border-radius: ${border.radius};
    cursor: pointer;
`;

export const InfoSection = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
    width: auto;
    height: auto;
    min-height: 36px;
    margin-bottom: 23px;
`;

export const Label = styled.div`
    font-family: ${font.family.primary};
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0px;
    text-transform: uppercase;
`;

export const Separator = styled.div`
    width: 20px;
    height: 2px;
    background-color: #e2e2e2;
    border-radius: 4px;
`;

export const Status = styled.div<{color: string}>`
    position: relative;
    width: auto;
    height: auto;
    padding: 8px 10px;
    color: ${(p) => p.color};
    border-radius: 4px;
    overflow: hidden;

    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 14px;
    letter-spacing: 0%;

    text-transform: capitalize;

    &:after {
        position: absolute;
        top: 0;
        right: 0;
        content: '';
        width: 100%;
        height: 100%;
        background-color: ${(p) => p.color};
        opacity: 0.1;
    }
`;

export const InvoiceIdContainer = styled.div`
    display: flex;
    gap: 10px;
    justify-content: flex-start;
`;
export const InvoiceId = styled.span`
    display: flex;
    whitespace: no-wrap;
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0%;
    color: ${colors.textSecondary};
`;
export const InvoiceIdCopyButton = styled.button`
    width 20px;
    height: 20px;
    background-image: url("${icons.copyToClipboard}");
    background-size: initial;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    padding: 0;
    border: 0;
    outline: 0;
    background-color: transparent;
`;

export const DownloadButtonSpan = styled.span`
    display: flex;
    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    color: inherit;
`;

export const DownloadButtonIcon = styled.div<{actionType: string}>`
    width: 16px;
    height: 16px;
    background-image: ${(p) => `url("${icons[p.actionType as keyof typeof icons]}")`};
    background-size: initial;
    background-position: center;
    background-repeat: no-repeat;
`;

export const CloseAndLinkBack = styled(Link)`
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    height: auto;
    padding: 0;
    gap: 8px;
`;

export const CloseAndLinkBackText = styled.span`
    display: flex;
    font-family: ${font.family.primary};
    font-weight: 500;
    font-style: Bold;
    font-size: 14px;
    line-height: 18px;
`;

export const CloseAndLinkBackIcon = styled.div`
    width: 16px;
    height: 16px;
    background-image: url("${icons.close}");
    background-size: initial;
    background-position: center;
    background-repeat: no-repeat;
`;

export const ButtonWIcon = styled.button<{actionType: string}>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    height: auto;
    padding: ${(p) => (p.actionType === 'close' ? `0` : '10px 16px')};
    border: 1px solid
        ${(p) => {
            switch (p.actionType) {
                case 'reject':
                    return colors.red;
                case 'accept':
                    return colors.brandPrimary;
                case 'close':
                    return 'transparent';

                default:
                    colors.white;
            }
        }};
    border-radius: ${border.radius};
    cursor: pointer;
    outline: 0;
    background-color: ${(p) => {
        switch (p.actionType) {
            case 'reject':
                return colors.white;
            case 'accept':
                return colors.brandPrimary;
            case 'close':
                return 'transparent';

            default:
                colors.white;
        }
    }};
    cursor: pointer;
    gap: 8px;
    color: ${(p) => {
        switch (p.actionType) {
            case 'reject':
                return colors.red;
            case 'accept':
                return colors.white;
            case 'close':
                return colors.brandPrimary;

            default:
                colors.white;
        }
    }};
    ${(p) => p.actionType === 'close' && `margin-bottom: 16px`};

    :hover {
        color: ${(p) => {
            switch (p.actionType) {
                case 'close':
                    return colors.brandDark;
            }
        }};
    }
`;

export const StatusButtonsWrapper = styled.div`
    margin-left: auto;
    display: flex;
    gap: 10px;
`;

export const Wrapper = styled.div`
    width: auto;
    height: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
`;

export const ParentId = styled.div`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0%;
    color: ${colors.textGrey1};
    margin-bottom: 15px;
`;
